import initPromise from "./utils/handleApp"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./plugins/element.js"
import "./plugins/vxeTable"
import "./plugins/perfectScrollBar"
import "./plugins/tooltip"
import "./plugins/clickOutside"
import store from "./store"
import lodash from "lodash"
import * as echarts from "echarts"

import "viewerjs/dist/viewer.css"
import Viewer from "v-viewer"
Vue.use(Viewer)

import VueAMap from "vue-amap"
Vue.use(VueAMap)
window._AMapSecurityConfig = {
  securityJsCode: "0cf6e49d4a00fdfdf510982bc954d051"
}
VueAMap.initAMapApiLoader({
  key: "fce84e13ee26fe4749b57c4bc00bef95",
  plugin: ["PlaceSearch", "Autocomplete", "Geolocation", "Geocoder"],
  uiVersion: "1.1.1"
})

import "@/permission" // permission control
import "@/styles/index.scss" // global css
import "@/icons" // icon
import "./registerServiceWorker"
import { setToken } from "./utils/tokenManager"

Vue.config.productionTip = false
Vue.prototype._ = lodash
Vue.prototype.$echarts = echarts

let doMount = async () => {
  let token = await initPromise
  let { qd__fromApp } = window
  const share = window.location.pathname.includes("board/share")
    ? window.location.pathname.split("/")[3]
    : null
  // app内打开
  if (qd__fromApp) {
    token && setToken(token, share)
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app")
}
doMount()
